import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.jsx';
// Fonts first: the @font-face declarations must be registered before the rules
// that reference the family.
import './fonts.css';
import './styles.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
